'use client';

import { AdContainer } from './AdContainer';
import type { AdPlacementId } from './placements';

import './landing-incontent-ad.css';

const LANDING_PLACEMENTS = [
  'landing_home',
  'landing_resume_analyzer',
  'landing_europass_cv_builder',
  'landing_uae_cv_builder',
  'landing_examples_europass',
  'landing_examples_uae_jobs',
  'landing_examples_freshers',
] as const;

export type LandingInContentPlacementId = (typeof LANDING_PLACEMENTS)[number];

type LandingInContentAdProps = {
  placement: LandingInContentPlacementId;
};

/**
 * Below-fold, in-flow landing ad. Renders nothing when resolveAdSlot is none
 * (flag off / master off / mobile gated), so the page keeps no empty gap.
 */
export function LandingInContentAd({ placement }: LandingInContentAdProps) {
  return (
    <AdContainer
      placement={placement as AdPlacementId}
      className="landing-incontent-ad"
    />
  );
}
